import { buildQuery } from '@calendly/http-tools'

import { sanitizePaneProps } from './sanitize_props'

export const encodeState = (props) => {
  const sanitizedProps = props ? sanitizePaneProps(props) : null
  return sanitizedProps ? btoa(buildQuery(sanitizedProps)) : null
}
